import { RowData } from "@tanstack/react-table";

import { IColumnDef, IExtendableDto } from "@ryde/shared";

import { TableSettingsDrawer } from "./table-settings.drawer";

interface ITableSettingsDrawerWrapperGeneric<
  T extends IExtendableDto & RowData,
> {
  tableDefs: IColumnDef<T, unknown>[];
}

export const TableSettingsDrawerWrapperGeneric = <
  T extends IExtendableDto & RowData,
>({
  tableDefs,
}: ITableSettingsDrawerWrapperGeneric<T>): JSX.Element => {
  return (
    <TableSettingsDrawer<T>
      tableDefs={tableDefs as IColumnDef<object, any>[]}
    />
  );
};
